import { jsx as _jsx } from "react/jsx-runtime";
import { getRootStore } from "@/stores/RootStore";
import styles from "@/styles/VehicleModelsPage.module.less";
import { canDeleteFromDictionaries, canEditDictionaries, } from "@/utils/permissions";
import { Button, Card, Modal, Skeleton, Tooltip } from "antd";
import { observer } from "mobx-react-lite";
import { useEffect } from "react";
import { DeleteOutlined, PlusOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router";
import { DataTable } from "@/components/DataTable";
import { Filters } from "@/components/filters";
export const VehicleModelsPage = observer(() => {
    const { authStore, vehicleModelsStore } = getRootStore();
    const { dataTable, loading, filtersStore } = vehicleModelsStore;
    const navigate = useNavigate();
    // Определяем права доступа
    const userRole = authStore.userRole;
    const canEdit = canEditDictionaries(userRole);
    const canDelete = canDeleteFromDictionaries(userRole);
    useEffect(() => {
        dataTable.setFilters(filtersStore.values);
        dataTable.loadData();
    }, [filtersStore.values]);
    const handleViewVehicleModel = (vehicleModelId) => {
        if (vehicleModelId) {
            navigate(`/vehicle-models/${vehicleModelId}`);
        }
        else {
            navigate("/vehicle-models/new");
        }
    };
    const handleDeleteVehicleModel = (vehicleModelId) => {
        Modal.confirm({
            title: "Удалить модель автомобиля?",
            content: "Вы уверены, что хотите удалить эту модель автомобиля?",
            okText: "Удалить",
            okType: "danger",
            cancelText: "Отмена",
            onOk: () => vehicleModelsStore.deleteVehicleModel(vehicleModelId),
        });
    };
    const columns = [
        {
            title: "Название",
            key: "model",
            sorter: true,
            dataIndex: "model",
            width: 150,
            render: (_, record) => (_jsx(Button, { type: "link", onClick: () => handleViewVehicleModel(record.id), children: record.model })),
        },
        {
            title: "Производитель",
            key: "manufacturerName",
            dataIndex: "manufacturerName",
            sorter: true,
            width: 150,
            render: (_, record) => (_jsx("span", { children: record.manufacturerName })),
        },
        {
            title: "Год выпуска",
            key: "releaseYear",
            width: 100,
            sorter: true,
            dataIndex: "releaseYear",
            render: (_, record) => (_jsx("span", { children: record.releaseYear })),
        },
        {
            title: "Месяц выпуска",
            key: "releaseMonth",
            width: 100,
            sorter: true,
            dataIndex: "releaseMonth",
            render: (_, record) => (_jsx("span", { children: record.releaseMonth })),
        },
        {
            title: "Размер батареи, А*ч",
            key: "usableBatterySize",
            width: 120,
            sorter: true,
            dataIndex: "usableBatterySize",
            render: (_, record) => (_jsx("span", { children: record.usableBatterySize })),
        },
        {
            title: "Тип автомобиля",
            key: "vehicleType",
            width: 100,
            sorter: true,
            dataIndex: "vehicleType",
            render: (_, record) => (_jsx("span", { children: record.vehicleType })),
        },
        {
            title: "Макс. мощность зарядки, кВт",
            key: "dcMaxPower",
            width: 100,
            sorter: true,
            dataIndex: "dcMaxPower",
            render: (_, record) => (_jsx("span", { children: record.dcMaxPower })),
        },
        {
            title: "Поддерживаемые разъемы",
            key: "dcPorts",
            width: 100,
            render: (_, record) => (_jsx("span", { children: record.dcPorts.join(", ") })),
        },
        {
            title: "Действия",
            key: "actions",
            width: 80,
            render: (_, record) => canDelete && (_jsx(Tooltip, { title: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C", children: _jsx(Button, { type: "text", icon: _jsx(DeleteOutlined, {}), danger: true, size: "small", onClick: () => handleDeleteVehicleModel(record.id) }) })),
        },
    ];
    const dataTableConfig = {
        header: {
            title: "Модели автомобилей",
            actions: canEdit ? (_jsx(Button, { type: "primary", icon: _jsx(PlusOutlined, {}), onClick: () => handleViewVehicleModel(), children: "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u043C\u043E\u0434\u0435\u043B\u044C \u0430\u0432\u0442\u043E\u043C\u043E\u0431\u0438\u043B\u044F" })) : undefined,
            extraContent: (_jsx(Filters, { filtersStore: filtersStore, title: "\u0424\u0438\u043B\u044C\u0442\u0440\u044B \u0438 \u043F\u043E\u0438\u0441\u043A", showClearAll: true, showApplyButton: false })),
        },
        columns: columns,
        rowKey: "id",
        scroll: { x: 1400 },
    };
    if (loading) {
        return (_jsx("div", { className: styles.container, children: _jsx(Card, { children: _jsx(Skeleton, { active: true, paragraph: { rows: 8 } }) }) }));
    }
    return _jsx(DataTable, { store: dataTable, config: dataTableConfig });
});
export default VehicleModelsPage;
